import script from "./BDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BDialog.vue?vue&type=style&index=0&id=5d742255&lang=scss"

const __exports__ = script;

export default __exports__